import { Component } from '@theme/component';

/**
 * Savings calculator for Mr. Wine. Every wine and case combination is rendered in Liquid;
 * this component only shows the panel that matches the pressed wine and case buttons.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} wineButtons - One button per wine.
 * @property {HTMLButtonElement[]} caseButtons - One button per number of cases.
 * @property {HTMLElement[]} panels - One panel per wine and number of cases.
 *
 * @extends Component<Refs>
 */
class MwSavingsComponent extends Component {
  requiredRefs = ['wineButtons', 'caseButtons', 'panels'];

  #wine = '0';
  #cases = '1';

  /** @param {MouseEvent} event */
  selectWine(event) {
    const button = event.target;
    if (!(button instanceof HTMLButtonElement) || !button.dataset.wine) return;

    this.#wine = button.dataset.wine;
    this.#press(this.refs.wineButtons, button);
    this.#showPanel();
  }

  /** @param {MouseEvent} event */
  selectCases(event) {
    const button = event.target;
    if (!(button instanceof HTMLButtonElement) || !button.dataset.cases) return;

    this.#cases = button.dataset.cases;
    this.#press(this.refs.caseButtons, button);
    this.#showPanel();
  }

  /**
   * @param {HTMLButtonElement[]} buttons
   * @param {HTMLButtonElement} pressed
   */
  #press(buttons, pressed) {
    for (const button of buttons) {
      button.setAttribute('aria-pressed', String(button === pressed));
    }
  }

  #showPanel() {
    for (const panel of this.refs.panels) {
      panel.hidden = panel.dataset.wine !== this.#wine || panel.dataset.cases !== this.#cases;
    }
  }
}

if (!customElements.get('mw-savings-component')) {
  customElements.define('mw-savings-component', MwSavingsComponent);
}
